const fakeData = [
  {
    id: 1,
    designation: "Technology",
    title: "Next-Gen Web Platforms",
    img: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=400&q=40&auto=format",
    category: "technology",
  },
  {
    id: 2,
    designation: "Technology",
    title: "Cloud & Scalable Systems",
    img: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=400&q=40&auto=format",
    category: "technology",
  },
  {
    id: 3,
    designation: "SNEW AI",
    title: "AI Automation",
    img: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=400&q=40&auto=format",
    category: "ai",
  },
  {
    id: 4,
    designation: "Events",
    title: "Corporate Events",
    img: "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=400&q=40&auto=format",
    category: "events",
  },
  {
    id: 5,
    designation: "Media",
    title: "Video Production",
    img: "https://images.unsplash.com/photo-1492724441997-5dc865305da7?w=400&q=40&auto=format",
    category: "media",
  },
  {
    id: 6,
    designation: "Logistics",
    title: "Global Shipping",
    img: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=400&q=40&auto=format",
    category: "logistics",
  },
  {
    id: 7,
    designation: "Food Products",
    title: "Food Innovations",
    img: "https://images.unsplash.com/photo-1606787366850-de6330128bfc?w=400&q=40&auto=format",
    category: "food",
  },
  {
    id: 8,
    designation: "Electronics",
    title: "Smart Devices",
    img: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=400&q=40&auto=format",
    category: "electronics",
  },
  {
    id: 9,
    designation: "SNEW SPACE",
    title: "Interior Design",
    img: "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=400&q=40&auto=format",
    category: "space",
  },
];

export default fakeData;
